import { render, staticRenderFns } from "./editListData.vue?vue&type=template&id=039dbfc5&scoped=true"
import script from "./editListData.vue?vue&type=script&lang=js"
export * from "./editListData.vue?vue&type=script&lang=js"
import style0 from "./editListData.vue?vue&type=style&index=0&id=039dbfc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039dbfc5",
  null
  
)

export default component.exports